import { type ToastMessageOptions, useToast } from "primevue";

export class ToastFacade {
    private toast = useToast();

    public show(options: ToastMessageOptions) {
        this.toast.add(options);
    }

    public notify(options: ToastMessageOptions) {
        this.toast.add({
            ...options,
            group: "notification",
            summary: "Pemberitahuan",
            severity: "warn",
        });
    }
}
